import { omit } from "lodash";
import { formatAPIDate } from "../libs/common_utils";

// ReportModel class for standard reports from Reporting (performance, geo, app-transparency)
export default class ReportModel {
  constructor({
    type = null,
    startDate = null,
    endDate = null,
    advertiserId = 0,
    campaignIds = [],
    dimensions = [],
    metrics = [],
    output = "json",
    reportingPeriod = null,
    timeRollup = null,
  } = {}) {
    this.type = type;
    this.advertiser_id = advertiserId;
    this.campaign_ids = campaignIds;
    this.dimensions = dimensions;
    this.metrics = metrics;
    this.output = output;
    this.time_rollup = timeRollup;
    this.start_date = startDate;
    this.end_date = endDate;
    this.reporting_period = reportingPeriod;
  }

  /**
   * convert model into json format
   * reporting period is not needed if start_date and end_date are provided and vice versa
   * @return {object}
   */
  toJson() {
    const json = { ...this };
    const keysToOmit = [];
    if (this.reporting_period === "custom" && this.start_date && this.end_date) {
      json.start_date = formatAPIDate(this.start_date);
      json.end_date = formatAPIDate(this.end_date);
      keysToOmit.push("reporting_period");
    } else {
      keysToOmit.push("start_date");
      keysToOmit.push("end_date");
    }

    return omit(json, keysToOmit);
  }
}
